/*
 * providers
 */
import { QueryClient } from "@tanstack/react-query"
import { AuthProvider } from "@emr/auth/client"
import { DevProvider } from "@emr/dev"
import { ThemeProvider } from "@emr/theme"
import { ErrorBoundary, NetworkToast } from "@emr/react-components"
import { Toaster } from "@emr/react-ui"
import { TrpcProvider } from "@emr/trpc/client"
import type { ReactNode } from "react"
import { trpc, trpcClient } from "./trpc"

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0, // 1000 * 60, // 1 minute
			retry: 0,
			refetchOnWindowFocus: false, // Optional: disable refetch on window focus
		},
	},
})

type ProvidersProps = {
	children: ReactNode
}

export default function Providers({ children }: ProvidersProps) {
	return (
		<ErrorBoundary>
			<AuthProvider>
				<TrpcProvider
					trpc={trpc}
					trpcClient={trpcClient}
					queryClient={queryClient}
				>
					<DevProvider>
						<ThemeProvider>
							{children}
							<Toaster />
							<NetworkToast />
						</ThemeProvider>
					</DevProvider>
				</TrpcProvider>
			</AuthProvider>
		</ErrorBoundary>
	)
}
